<template>
  <v-app
    style="background-image: linear-gradient( to top right,  rgb(229, 219, 235) , rgba(244,248,252) );"
  >
    <v-app-bar
      :style="
        $vuetify.breakpoint.smAndDown ? 'max-height: 56px !important' : null
      "
      :app="$vuetify.breakpoint.mdAndUp"
      :color="$vuetify.breakpoint.smAndDown ? `transparent` : `#23282D`"
      :flat="$vuetify.breakpoint.smAndDown"
      :scroll-off-screen="true"
    >
      <router-link :to="$i18nRoute({ name: 'home' })">
        <v-img
          class="ml-n1"
          src="https://clinicaapps.blob.core.windows.net/static/images/assets/images/logo.svg"
          max-width="42"
          contain
          :to="$i18nRoute({ name: 'home' })"
        ></v-img>
      </router-link>
      <v-toolbar-title
        class="font-weight-medium white--text ml-2"
        v-if="$vuetify.breakpoint.mdAndUp"
      >
        Clinica
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        small
        rounded
        text
        @click.stop="drawer = !drawer"
        class="subtitle-2 font-weight-bold"
      >
        <v-icon
          :small="$vuetify.breakpoint.smAndDown"
          @click.stop="drawer = !drawer"
          left
          :class="
            $vuetify.breakpoint.smAndDown
              ? 'primary__gradient_text'
              : 'white--text'
          "
          >mdi-earth</v-icon
        >
        <span
          :class="
            $vuetify.breakpoint.smAndDown
              ? 'primary__gradient_text'
              : 'white--text'
          "
          >{{ this.$i18n.locale }}</span
        >
      </v-btn>
      <v-btn
        small
        v-if="$store.state.isAuth"
        text
        @click.stop="drawer = !drawer"
        :class="$vuetify.breakpoint.smAndDown ? 'primary__gradient_text' : null"
        class="subtitle-2 font-weight-bold rounded-xl"
      >
        <span
          :class="
            $vuetify.breakpoint.smAndDown
              ? 'primary__gradient_text'
              : 'white--text'
          "
          >{{ $t("button.logOut") }}</span
        >
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      temporary
      right
      app
      :bottom="$vuetify.breakpoint.smAndDown"
    >
      <v-list dense nav>
        <v-subheader
          ><v-icon class="pr-2">mdi-earth</v-icon
          >{{ $i18n.locale == "en" ? `Language` : `Idioma` }}</v-subheader
        >
        <v-divider></v-divider>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          :disabled="$i18n.locale == item.locale"
          @click="setLocale(item)"
        >
          <v-list-item-title>{{ item.language }}</v-list-item-title>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn
            v-if="$store.state.isAuth"
            block
            color="secondary__gradient"
            @click="logOut()"
            :ripple="false"
            dark
          >
            {{ $t("button.logOut") }}
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-main>
      <!-- <v-alert
        key="2"
        type="error"
        text
        v-html="$t(`error.newAppointmentsUnavailable`)"
      >
      </v-alert> -->
      <v-fade-transition mode="out-in">
        <template v-if="$store.state.loading.patientLoad">
          <v-overlay :value="$store.state.loading.patientLoad">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </template>
        <template v-else-if="$store.state.error.initialPatientLoad">
          <v-container>
            <v-alert color="primary" dark>
              <v-row align="center">
                <v-col
                  class="grow font-weight-bold"
                  v-html="$t(`error.initialPatientLoad`)"
                >
                </v-col>
                <v-col
                  class="shrink"
                  :cols="$vuetify.breakpoint.smAndDown ? '12' : null"
                >
                  <v-btn rounded @click="$router.go()" color="white"
                    ><span class="primary__gradient_text font-weight-bold">{{
                      $t("button.retry")
                    }}</span></v-btn
                  >
                </v-col>
              </v-row>
            </v-alert>
          </v-container>
        </template>
        <router-view v-else />
      </v-fade-transition>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    drawer: null,
    links: [
      { title: "Main Clinica Website", link: "https://www.clinica.org/" },
      { title: "Schedule Appointment", link: "" },
    ],
    items: [
      { language: "English", locale: "en" },
      { language: "Español", locale: "es" },
    ],
  }),
  computed: {},
  watch: {},
  mounted() {
    this.refreshLocale();
    this.$watch(
      "$i18n.locale",
      (newLocale, oldLocale) => {
        if (newLocale === oldLocale) {
          return;
        }
        this.refreshLocale();
      },
      { immediate: true }
    );
  },
  methods: {
    logOut() {
      this.axios.post("nextgen/logout").then((response) => {
        this.$store.commit("setAuth", false);
        this.$store.commit("erasePerson");
        this.$router.push(
          this.$i18nRoute({
            name: "landing",
            query: {
              logout: true,
            },
          })
        );
      });
    },
    setLocale(item) {
      const lang = item.locale;
      const to = this.$router.resolve({
        params: { lang },
        query: this.$route.query,
      });
      this.$i18n.locale = lang;
      this.$router.push(to.location);
    },
    refreshLocale() {
      var items = this.items;
      var result = items.find((obj) => {
        return obj.locale === this.$i18n.locale; //this.$route.params.lang ;
      });
      if (result) {
        this.$i18n.locale = result.locale;
        this.moment.locale(this.$i18n.locale);
      }
    },
  },
};
</script>
<style>
.hero {
  background-image: linear-gradient(
    to top right,
    rgb(229, 219, 235),
    rgba(244, 248, 252, 1)
  );
  /* background-image: linear-gradient(120deg, #a6c0fe 0%, #f68084 100%); */
}

.hero::before {
  content: "";
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  background-color: rgba(255, 255, 255, 0.2);
}
.secondary__gradient {
  background: linear-gradient(170deg, #14b1aa 5%, #066c7e 80%) !important;
  -webkit-transition: background 2s ease-out;
  -moz-transition: background 0.5s ease-out;
  -o-transition: background 0.5s ease-out;
  transition: background 0.5s ease-out;
}
.primary__gradient {
  background: linear-gradient(175deg, #792f5b, #973972) !important;
  -webkit-transition: background 2s ease-out;
  -moz-transition: background 5s ease-out;
  -o-transition: background 5s ease-out;
  transition: background 1s ease-out;
}
.primary__gradient:hover {
  background: linear-gradient(200deg, #792f5b, #973972) !important;
  -webkit-transition: background 4s ease-out;
  -moz-transition: background 5s ease-out;
  -o-transition: background 5s ease-out;
  transition: background 4s ease-out;
}
.theme--dark.v-sheet.gradient {
  border-color: rgba(255, 255, 255, 0.2);
}
.primary__gradient_text {
  background: -webkit-linear-gradient(175deg, #ad5389, #762c58);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.v-card__title {
  word-break: normal !important;
}
</style>
